import { render, staticRenderFns } from "./SolePropI.vue?vue&type=template&id=5a414020"
import script from "./SolePropI.vue?vue&type=script&lang=js"
export * from "./SolePropI.vue?vue&type=script&lang=js"
import style0 from "./SolePropI.vue?vue&type=style&index=0&id=5a414020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports